export enum RequestStatus {
	Pending = 'pending',
	Closed = 'closed',
	Deleted = 'deleted',
}